export const convertKebabToMacroCase = (input: string) =>
  input.toUpperCase().replace(/-/g, '_')

export const convertMacroToKebabCase = (input: string) =>
  input.toLowerCase().replace(/_/g, '-')
